/**
 *******************
MEMO:既存変数の修正はtsファイル、cssファイル両方に実施してください
 ********************
 */

import { IMAGE_PATH_ROOT_ALL, IMAGE_PATH_ROOT_PC, IMAGE_PATH_ROOT_SP } from '@/domain/constants/ImagePath';

/**
 ********
  ●変数の命名規則
  大分類ごとにオブジェクトに入れて管理しています。オブジェクトの名前は{要素やプロパティ}です。
  そのオブジェクトの中のプロパティとしてそれぞれの値を {詳細}_{デバイス}:'{値}' の形式で入れています。
 
  ・要素やプロパティ
  htmlの要素やcssのプロパティの略語などの大カテゴリが把握できる単語（例：imgなど）
 
  ・詳細
  その要素の詳細な部分 2単語以上になってもOK（例：thumbnail-small, bor-lv1など）
 
  ・デバイス
  pc, sp, commonのいずれか
 
  ●使用方法
  ① 変数を管理しているこのファイルから使いたいオブジェクトを読み込む
  例）import { fontSize } from '../../../../common/css/setting/variable';
 
  ② 各要素の中で展開する
  例）const Icon = styled.header`
    font-size: ${fontSize.px11};
  `;
 *********
 */
/**
 * サイズ size
 */
export const size = {
  /* PC カラム幅 */
  width_content_pc: '990px',
  width_mainColumn_pc: '672px',
  width_mainColumnWithBorder_pc: '674px',
  width_sideColumn_pc: '300px',
  margin_left_sideColumn_pc: '16px',

  /* PC サムネイル */
  thumbnail_writer_pc: '50px', // オーサー、コメンテーター用のサムネイル
  thumbnail_small_pc: '60px',
  thumbnail_middle_pc: '80px',
  thumbnail_large_pc: '100px',
  thumbnail_wide_width_pc: '200px',
  thumbnail_wide_height_pc: '112px',
  thumbnail_wide_19X10_width_pc: '200px',
  thumbnail_wide_19X10_height_pc: '105px',

  /* PC インフィード広告サムネイル */
  thumbnail_ad_infeedLarge_width_pc: '200px',
  thumbnail_ad_infeedLarge_height_pc: '105px',

  /* SP サムネイル */
  thumbnail_writer_sp: '50px', // オーサー、コメンテーター用のサムネイル
  thumbnail_xsmall_sp: '46px',
  thumbnail_small_sp: '52px',
  thumbnail_middle_sp: '96px',
  thumbnail_wide_width_sp: '100%',
  thumbnail_wide_height_sp: 'calc((100vw - 16px) * 52 / 100)',
  thumbnail_topicsRatio_flash_width_sp: '100%',
  thumbnail_topicsRatio_flash_height_sp:
    'calc((100vw - 34px) * (93 / 225))' /* トピックスのワイド画像比率（1:2.414）で左右の余白は速報版 */,
  thumbnail_topicsRatio_top_width_sp: '100%',
  thumbnail_topicsRatio_top_height_sp:
    'calc((100vw - 10px) * (93 / 225))' /* トピックスのワイド画像比率（1:2.414）で左右の余白はトップ版 */,
  thumbnail_pickup_width_sp: '100%',
  thumbnail_pickup_height_sp: 'auto',

  /* お知らせ枠サムネイル(Icon) */
  thumbnail_notice_common: '40px',

  /* PC サムネイル 記事詳細パラグラフ用 */
  thumbnail_article_paragraph_pc: '200px',

  /* PC サムネイル 記事詳細関連有料記事用 */
  thumbnail_article_payment_pc: '110px',

  /* SP サムネイル 記事詳細関連有料記事用 */
  thumbnail_article_payment_sp: '100px',

  /* PC,SP共通 サムネイル 動画サムネイル用 */
  thumbnail_movie_width_common: '170px',
  thumbnail_movie_height_common: '96px',

  /* SP モジュール間の区切り線 */
  divider_height_sp: '8px',

  /* PC ライブプレーヤーサイズ */
  live_player_pc: '685px',

  /* PC ライブbreaking時の余白 */
  live_breaking_pc_space: '46px',

  /* PC ライブプレイヤーの高さ */
  live_player_pc_height_breaking: '492px' /** live_player_pc_height + live_breaking_pc_space */,
  live_player_pc_height: '446px',

  /* SP ライブプレイヤーの高さ */
  live_player_sp_height_breaking: 'calc(((100vw - 64px) * 9 / 16) + 40px)' /** breakingタイトル分40pxを加算する */,
  live_player_sp_height: 'calc((100vw - 64px) * 9 / 16)',

  /* SP ライブ枠の高さ（プレイヤー+タイトル+番組表) */
  live_carousel_sp_height_breaking:
    'calc(((100vw - 64px) * 9 / 16) + 32px + 40px)' /** breakingタイトル分40pxを加算する */,
  live_carousel_sp_height: 'calc(((100vw - 64px) * 9 / 16) + 32px + 31px)',

  /* PC サムネイル 写真詳細ランキング通常用（ワイドはResponsive） */
  thumbnail_photo_ranking_pc: '146px',
  /* SP サムネイル 写真詳細ランキング通常用（ワイドはResponsive） */
  thumbnail_photo_ranking_sp: '172px',

  /* PC サムネイル 写真詳細タイムライン用 */
  thumbnail_photo_newsfeed_pc: '192px',

  /* PC サムネイル 写真詳細サムネイルリスト用 */
  thumbnail_photo_thumbnail_list_pc: '92px',

  /* SP サムネイル 写真詳細サムネイルリスト用 */
  thumbnail_photo_thumbnail_list_sp: '70px',

  /* PC サムネイル トピ詳細 続報 */
  thumbnail_pickup_followUp_width_pc: '134px',
  thumbnail_pickup_followUp_height_pc: '55px',

  /* SP サムネイル トピ詳細 ココぽい */
  thumbnail_pickup_point_sp: '60px',

  /* PCSP コメントアイコン */
  comment_icon_xxsmall_common: '24px',
  comment_icon_xsmall_common: '28px',
  comment_icon_small_common: '32px',
  comment_icon_middle_common: '40px',
  comment_icon_large_common: '60px',
  comment_icon_floating_common: '44px',
  comment_icon_appeal_common: '24px',
  /* PCSP コメントアイコンにオーバーレイする+アイコンのサイズ(サイズはRiff IconV2のもの) */
  comment_icon_overlay_plus_icon_middle_common: 24,
  comment_icon_overlay_plus_icon_small_common: 22,
  comment_icon_overlay_plus_icon_xxsmall_common: 12,

  /* PCSP サムネイル コメンテータープロフィール プロフィール用 */
  thumbnail_profile_wrapper_common: '114px',
  thumbnail_profile_common: '108px',
  /* PC/SPユーザプロフィールアイコンサイズ */
  thumbnail_user_profile_common: '100px',

  /* PC アイコン オーサー */
  icon_author_pc: '28px',
  icon_author_sp: '32px',

  /*  PC,SP共通　みんなの意見グラフアイコン */
  polls_graph_icon_common: '14px',

  /*  PC,SP共通　みんなの意見棒グラフの高さ */
  polls_bar_graph_height_common: '12px',
  polls_bar_graph_height_middle_common: '16px',
  polls_bar_graph_height_large_common: '24px',

  /* PC サムネイル みんなの意見用 */
  thumbnail_polls_small_width_pc: '134px',
  thumbnail_polls_small_height_pc: '55px',
  thumbnail_polls_middle_width_pc: '303px',
  thumbnail_polls_middle_height_pc: '125px',

  /* SP コメント 顔出し丸アイコンサイズ */
  comment_circle_icon_sp: '18px',

  /* PC コメント 顔出し丸アイコンサイズ */
  comment_circle_icon_pc: '18px',

  /* SP トピックカードサムネイルサイズ */
  thumbnail_topiccard_width_sp: '64px',
  thumbnail_topiccard_height_sp: '64px',
  thumbnail_topiccard_large_width_sp: '150px',
  thumbnail_topiccard_large_height_sp: '150px',

  /* SP コンテキストラインサムネイルサイズ */
  thumbnail_contextline_width_sp: '72px',
  thumbnail_contextline_height_sp: '72px'
} as const;

/**
 * 文字 font
 */
export const font = {
  /* コメント数平均や動画再生時間 */
  number_common: 'arial, sans-serif'
} as const;

/**
 * レイヤー（z-index） layer
 */
export const layer = {
  /* PC,SP共通 */
  under_common: -1 /* 背景的に使いたい場合など */,
  base_common: 1 /* 通常 */,
  low_common: 50 /* 通常より上でmiddle未満に配置したい場合 */,
  middle_common: 100 /* ちょっと上げたい場合、absoluteにして被せたいときなど */,
  middle_high_common: 199 /* fixedな要素よりわずかに下に配置したい場合 */,
  high_common: 200 /* fixedな要素など */,
  /* 全社マストヘッド:5000000 */
  overlay_common: 5000100 /* 要素全体に被せるoverlayなど */,
  modal_common: 5000200 /* overlayの上で用いるモーダルなど */
} as const;

/**
 * 角丸 radius
 */
export const radius = {
  /* PC,SP共通汎用 */
  /* 例）リストマーク小(○) */
  small_common: '2px',
  /* 例）ボタンサイズが44px*44px未満のものは3pxを利用 */
  middleLow_common: '3px',
  /* 例）ボタン標準サイズ、リストマーク(○)、アラート枠や定期購読訴求枠のようなモジュール */
  middle_common: '4px',
  large_common: '6px',
  largeHigh_common: '8px',
  half_common: '50%',
  /* ラベル等*/
  label_common: '20px',
  /* 真円作成用*/
  trueCircle_common: '100%',

  /* PC,SP共通固有ローディングくるくる用 */
  loadingSpinner_common: '50%',
  loadingSpinnerInner_common: '100% 0 0 0',

  /* PC,SP共通固有コメンテータープロフィールのボタン */
  commentatorProf_button: '2px 2px 0 0',

  /* PC,SP共通固有ブレイキング見出し */
  breakingTitle_common: '1000px',

  /* PC,SP共通固有YSAボタン */
  ysaClose_common: '0 0 0 3px',
  ysaMore_common: '0 0 3px 0',

  /* PC固有検索モジュール */
  searchLeft_pc: '3px 0 0 3px',
  searchRight_pc: '0 3px 3px 0',
  searchBottom_pc: '0 0 3px 3px',
  /* SP固有検索モジュール */
  searchLeft_sp: '4px 0 0 4px',
  searchRight_sp: '0 4px 4px 0',

  /* PC,SP共通続報カレントラベル */
  followupLabel_common: '10px',

  /* PC固有続報フローティングカレントラベル */
  followupLabel_floating_pc: '100px',

  /* カテゴリータブSP用 */
  categoryTab_sp: '3px 3px 0 0',

  /* ニュースフィード動画ボタンSP用 */
  newsFeedMoviePlay_sp: '22px',

  /* ニュースフィード動画ボタンSP用 */
  newsFeedPullDown_sp: '8px 8px 0 0',

  /* SP固有検索ボタンSP用 */
  searchFrame_sp: '4px 0 0 4px',
  searchSubmit_sp: '0 4px 4px 0',

  /*  PC,SP共通　みんなの意見グラフアイコン */
  polls_graph_icon_common: '50%',

  /*  PC,SP共通　コメントプロフィールアイコン */
  comment_profile_icon_common: '50%',

  /* コメント要約新機能ラベル */
  comment_summary_new_function: '40px'
} as const;

/**
 * 透明度 opacity
 */
export const opacity = {
  /*  PC,SP共通 表示/非表示 */
  show_common: '1',
  hidden_common: '0',

  /* PC hover */
  hover_link_pc: '0.8' /* デフォルト */,
  hover_btn_pc: '0.5' /* ボタン */,

  /* PC,SP共通 SkeletonScreen */
  skeletonScreen_max_common: '1',
  skeletonScreen_min_common: '0.7',

  /* PC,SP共通 Modal */
  modal_overlay_pc: '0.5',

  /* ライブ  */
  live_inactive_common: '0.4',
  live_hover_active_pc: '1',

  /* トピックス */
  pickup_gradation_common: '0.7',

  /* SP その他 */
  topics_primary_subtext_sp: '0.7',
  backToTop_sp: '0.6'
} as const;

/**
 * パス path
 * 画像の場合は img_ を接頭辞としてつけてください
 */

/* 開発環境でlocalの画像パス指定 */
/* src/public/images/all/hogehogeの画像のパスを置き換え */
const imagePathRootAll = IMAGE_PATH_ROOT_ALL;
/* src/public/images/all/hogehogeの画像のパスを置き換え */
const imagePathRootPc = IMAGE_PATH_ROOT_PC;
const imagePathRootSp = IMAGE_PATH_ROOT_SP;

export const path = {
  /** 共通 */
  /* PC フッターナビゲーションアイコン */
  img_icon_footerNavigation_pc: `${imagePathRootPc}/spr_footerNavigation_icon.png`,
  /* PC フッターナビゲーションアイコン (Twitter → X) */
  img_icon_footerNavigation_pc_v2: `${imagePathRootPc}/spr_footerNavigation_icon_v2.png`,

  /** PC/SP共通　ポイント、支払い系 */
  img_logo_PayPay: `${imagePathRootAll}/logo_paypay.png`,
  img_icon_PayPay: 'https://s.yimg.jp/c/icon/s/bsc/2.0/paypay40.png',

  /** PC/SP共通 デフォルト画像 */
  img_default_1x1: `${imagePathRootAll}/default_1x1_550_550.jpg`,

  /* ローディングアイコン　※mixinでも使用 */
  img_loading: `${imagePathRootAll}/loading.png`,

  /* ラベルアイコン */
  img_labelIcon_new: `${imagePathRootAll}/ico_new.svg`,
  img_labelIcon_live: `${imagePathRootAll}/ico_live.svg`,
  img_labelIcon_pay: `${imagePathRootAll}/ico_pay.svg`,
  img_labelIcon_pay_black: `${imagePathRootAll}/ico_pay_black.svg`,
  img_labelIcon_trend: `${imagePathRootAll}/ico_trend.svg`,

  /* オリジナルラベル */
  img_label_original: `${imagePathRootAll}/ico_original.svg`,

  /** トップ */
  /* PC チャンネルロゴ */
  img_logo_nnn_pc: `${IMAGE_PATH_ROOT_ALL}/logo_live_nnn.png`,
  img_logo_jnn_pc: `${IMAGE_PATH_ROOT_ALL}/logo_live_jnn_v202204.png`,

  /* SP 主要LIVE動画掲出時のチャンネルロゴ */
  img_logo_nnn_sp: `${IMAGE_PATH_ROOT_SP}/logo_embed_nnn.png`,
  img_logo_jnn_sp: `${IMAGE_PATH_ROOT_SP}/logo_embed_jnn_v202204.png`,

  /** トピックス詳細 */
  /* ココポイ　けんさくえんじん */
  img_pickup_kensaku: `${imagePathRootAll}/pickupPoint_kensaku.svg`,
  /* Q&Aアイコン*/
  img_pickup_icon_Q: `${imagePathRootAll}/pickupPoint_Q.svg`,
  img_pickup_icon_A: `${imagePathRootAll}/pickupPoint_A.svg`,
  img_pickup_icon_Q_v202409: `${imagePathRootAll}/pickupPoint_Q_v202409.svg`,
  img_pickup_icon_AI: `${imagePathRootAll}/pickupPoint_AI.svg`,

  /* AIエージェント */
  img_pickup_label_ai_mediumPrimaryCheck_gray: `${imagePathRootAll}/pickup_label_ai_mediumPrimaryCheck_gray.svg`,
  img_pickup_label_ai_mediumPrimaryCheck_dark_gray: `${imagePathRootAll}/pickup_label_ai_mediumPrimaryCheck_dark_gray.svg`,
  img_pickup_label_ai_mediumPrimaryCheck: `${imagePathRootAll}/pickup_label_ai_mediumPrimaryCheck.svg`,
  img_pickup_label_aiSummary_mediumPrimaryCheck: `${imagePathRootAll}/pickup_label_aiSummary_mediumPrimaryCheck.svg`,
  img_pickup_label_ai_background: `${imagePathRootAll}/pickup_label_aiSummary_background.svg`,
  img_pickup_label_agent_i_gray: `${imagePathRootAll}/pickup_label_agent_i_gray.svg`,
  img_pickup_label_agent_i: `${imagePathRootAll}/pickup_label_agent_i.svg`,
  img_pickup_label_contextLine_check: `${imagePathRootAll}/pickup_label_contextLine_check.svg`,

  /* PC続報カレントアイコン（ABテスト用） */
  img_pickup_icon_current: `${imagePathRootPc}/followUp_ico_current.svg`,
  /* PC エンベッドライブ動画アイコン */
  img_icon_live_streaming_pc: `${imagePathRootPc}/icon_live_streaming.svg`,
  /* SP エンベッドライブ動画アイコン */
  img_icon_live_streaming_sp: `${imagePathRootSp}/icon_live_streaming.svg`,
  /* 安否確認アイコン */
  img_pickup_icon_safety_check: `${imagePathRootPc}/icon_topics_safety_check.png`,
  img_pickup_icon_line_safety_check: `${imagePathRootSp}/icon_topics_line_safety_check.png`,

  /** 記事詳細 */
  img_newsarticle_lineAm: `${imagePathRootSp}/line_am.png`,

  /** タイムライン */
  /* 動画記事 動画音量アイコン */
  img_newsfeed_videoVolume: `${imagePathRootSp}/ico_video_volume.gif`,
  /* みんなの意見アイコン（ABテスト用） */
  img_newsfeed_pieGraph: `${imagePathRootSp}/pie_graph.svg`,

  /** コメンテーター */
  /* snsアイコン */
  img_profile_icon_facebook: `${imagePathRootAll}/sns_facebook_circle.svg`,
  img_profile_icon_instagram: `${imagePathRootAll}/sns_instagram_circle.svg`,
  img_profile_icon_instagram_flat: `${imagePathRootAll}/sns_instagram_circle_flat.svg`,
  img_profile_icon_youtube: `${imagePathRootAll}/sns_youtube_circle.svg`,
  /* プロフィールデフォルトカバー画像 */
  img_profile_default_creator_cover: `${imagePathRootAll}/default_creator_profile_cover.jpg`,

  /* ヤフコメポリシー けんさくえんじん画像 */
  img_commentPolicy_title_pc: `${imagePathRootPc}/commentPolicy_title_pc.png`,
  img_commentPolicy_title_sp: `${imagePathRootSp}/commentPolicy_title_sp.png`,
  img_commentPolicy_news_chara_v2: `${imagePathRootAll}/commentPolicy_news_chara_v2.png`,
  img_commentPolicy_relief: `${imagePathRootAll}/commentPolicy_relief.png`,
  img_commentPolicy_restriction: `${imagePathRootAll}/commentPolicy_restriction.png`,
  img_commentPolicy_patrol: `${imagePathRootAll}/commentPolicy_patrol.png`,
  img_commentPolicy_hide: `${imagePathRootAll}/commentPolicy_hide.png`,

  /* コメント感情グラフ ヤフコメまとめロゴ */
  img_comment_emotion_logo: `${imagePathRootSp}/ai-messenger_solid.svg`,

  /* サービス運営方針 */
  img_newsOperationPolicy_topics_pc: `${imagePathRootPc}/newsOperationPolicy_topics2_pc.png`,
  img_newsOperationPolicy_topics_sp: `${imagePathRootSp}/newsOperationPolicy_topics2_sp.png`,
  img_newsOperationPolicy_timeline_pc: `${imagePathRootPc}/operationPolicy_timeline_pc.png`,
  img_newsOperationPolicy_timeline_sp: `${imagePathRootSp}/operationPolicy_timeline_sp.png`,
  img_newsOperationPolicy_main: `${imagePathRootAll}/newsOperationPolicy_main.png`,

  /* 記事入稿ガイドライン */
  img_articlesGuidelines_main: `${imagePathRootAll}/newsArticlesGuidelines_main.png`,

  /* アニュアルレポート フルパスではないので、後ろに「_2021_01.png」など数字を付けて使う*/
  img_annualReport_2021_pc: `${imagePathRootPc}/annualReport/annualReport`,
  img_annualReport_2021_sp: `${imagePathRootSp}/annualReport/annualReport`,
  img_annualReport_2022_pc: `${imagePathRootPc}/annualReport/annualReport`,
  img_annualReport_2022_sp: `${imagePathRootSp}/annualReport/annualReport`,
  img_annualReport_2023_pc: `${imagePathRootPc}/annualReport/annualReport`,
  img_annualReport_2023_sp: `${imagePathRootSp}/annualReport/annualReport`,
  img_annualReport_2024: `${imagePathRootAll}/annualReport/annualReport`,
  img_annualReport_2025: `${imagePathRootAll}/annualReport/annualReport`,
  img_annualReport_main: `${imagePathRootAll}/annualReport_main.png`,

  /* コメントプロフィールページ用設定アイコン */
  img_comment_iconSetting_addImage: `${imagePathRootAll}/comment_iconSetting_addImage.png`,
  img_comment_iconSetting_balloon: `${imagePathRootAll}/comment_iconSetting_balloon.png`,
  img_comment_iconSetting_baseball: `${imagePathRootAll}/comment_iconSetting_baseball.png`,
  img_comment_iconSetting_budgie: `${imagePathRootAll}/comment_iconSetting_budgie.png`,
  img_comment_iconSetting_clover: `${imagePathRootAll}/comment_iconSetting_clover.png`,
  img_comment_iconSetting_female: `${imagePathRootAll}/comment_iconSetting_female.png`,
  img_comment_iconSetting_greyRabbit: `${imagePathRootAll}/comment_iconSetting_greyRabbit.png`,
  img_comment_iconSetting_headphones: `${imagePathRootAll}/comment_iconSetting_headphones.png`,
  img_comment_iconSetting_koala: `${imagePathRootAll}/comment_iconSetting_koala.png`,
  img_comment_iconSetting_labrador: `${imagePathRootAll}/comment_iconSetting_labrador.png`,
  img_comment_iconSetting_lighthouse: `${imagePathRootAll}/comment_iconSetting_lighthouse.png`,
  img_comment_iconSetting_male: `${imagePathRootAll}/comment_iconSetting_male.png`,
  img_comment_iconSetting_onigiri: `${imagePathRootAll}/comment_iconSetting_onigiri.png`,
  img_comment_iconSetting_penguin: `${imagePathRootAll}/comment_iconSetting_penguin.png`,
  img_comment_iconSetting_rubberDuck: `${imagePathRootAll}/comment_iconSetting_rubberDuck.png`,
  img_comment_iconSetting_starCookie: `${imagePathRootAll}/comment_iconSetting_starCookie.png`,
  img_comment_iconSetting_strawberry: `${imagePathRootAll}/comment_iconSetting_strawberry.png`,
  img_comment_iconSetting_tabbyCat: `${imagePathRootAll}/comment_iconSetting_tabbyCat.png`,
  img_comment_iconSetting_toyCar: `${imagePathRootAll}/comment_iconSetting_toyCar.png`,
  img_comment_iconSetting_tulip: `${imagePathRootAll}/comment_iconSetting_tulip.png`,
  img_comment_iconSetting_grayCat: `${imagePathRootAll}/comment_iconSetting_grayCat.png`,
  img_comment_iconSetting_longTailedTit: `${imagePathRootAll}/comment_iconSetting_longTailedTit.png`,
  img_comment_iconSetting_mtFuji: `${imagePathRootAll}/comment_iconSetting_mtFuji.png`,
  img_comment_iconSetting_panda: `${imagePathRootAll}/comment_iconSetting_panda.png`,
  img_comment_iconSetting_pomeranian: `${imagePathRootAll}/comment_iconSetting_pomeranian.png`,
  img_comment_iconSetting_soccer: `${imagePathRootAll}/comment_iconSetting_soccer.png`,
  img_comment_iconSetting_sunflower: `${imagePathRootAll}/comment_iconSetting_sunflower.png`,
  /* コメントプロフィールアイコン設定誘導バナー */
  img_comment_iconSettingBanner_orange_pc: `${imagePathRootPc}/commentIconSettingBanner_orange_pc.png`,
  img_comment_iconSettingBanner_orange_sp: `${imagePathRootSp}/commentIconSettingBanner_orange_sp.png`,

  /* コメント要約モジュール_実行前 けんさく画像 */
  img_comment_summary_character: `${imagePathRootAll}/comment_summary_character.png`,

  /* コメント要約モジュール_成功時 けんさく画像 */
  img_comment_summary_success_character: `${imagePathRootAll}/comment_summary_success_character.png`,

  /* コメント要約モジュール ローディング中の吹き出し画像 */
  img_comment_summary_loading_speech_bubble: `${imagePathRootAll}/comment_summary_loading_speech_bubble.png`,

  /* コメント要約差し込みモジュール けんさく全身画像 */
  img_comment_summary_inset_character: `${imagePathRootAll}/comment_summary_inset_character.png`,

  /* みんなの意見 けんさくエンジン画像 */
  img_polls_character: `${imagePathRootAll}/polls_character_v202408.png`,

  /* pageError けんさく画像 */
  img_pageError_kensaku: `${imagePathRootAll}/bg_kensaku.gif`,

  /* ヤフコメタイムライン, コメント要約 */
  img_icon_comment_tl_new_comment: `${imagePathRootAll}/icon_newcmt.svg`,

  img_icon_expert_verified: `${imagePathRootAll}/ico_expert_verified.svg`,

  /* ヤフコメタイムライン誘導用素材 */
  img_icon_comment_tl: `${imagePathRootSp}/icon_cmttl.png`,

  /* フォロー */
  img_icon_unfollow: `${imagePathRootSp}/icon_unfollow.svg`,

  /* ユーザプロフィール設定促進モジュール けんさく画像 */
  img_user_profile_setting_character: `${imagePathRootAll}/user_profile_setting_character.png`,

  /* ベストエキスパートアワードアイコン */
  img_icon_best_expert_award: `${imagePathRootAll}/ico_best_expert_award.png`,

  /* エキスパートアイコン */
  img_icon_expert: `${imagePathRootAll}/ico_expert.png`,

  /**
   * エキスパートアイコン 高さ30px
   * （高さ15pxで表示させる用。画像サイズが表示サイズに対して整数倍になるようにしないと表示がぼやける場合があるため）
   */
  img_icon_expert_h30: `${imagePathRootAll}/ico_expert_h30.png`,

  /* エキスパート記事詳細 */
  /* ココポイ　けんさくえんじん */
  img_expert_article_pickup_kensaku: `${imagePathRootAll}/expert_article_pickup_kensaku.svg`,
  /* 引用アイコン */
  img_expert_article_quote: `${imagePathRootAll}/ico_expert_article_quote.svg`,

  /* 記事引用 */
  img_article_quote: `${imagePathRootAll}/article_quote.svg`,

  /** コメントリアクションアイコン */
  /** 共感したアイコン */
  img_icon_comment_empathy_default: `${imagePathRootAll}/icon_comment_empathy_default.png`,
  /** 共感したアイコン(投票済み) */
  img_icon_comment_empathy_voted: `${imagePathRootAll}/icon_comment_empathy_voted.png`,
  /** 共感したアイコン(disable) */
  img_icon_comment_empathy_disabled: `${imagePathRootAll}/icon_comment_empathy_disabled.png`,
  /** なるほどアイコン */
  img_icon_comment_insights_default: `${imagePathRootAll}/icon_comment_insights_default.png`,
  /** なるほどアイコン(投票済み) */
  img_icon_comment_insights_voted: `${imagePathRootAll}/icon_comment_insights_voted.png`,
  /** なるほどアイコン(disable) */
  img_icon_comment_insights_disabled: `${imagePathRootAll}/icon_comment_insights_disabled.png`,
  /** うーんアイコン */
  img_icon_comment_negative_default: `${imagePathRootAll}/icon_comment_negative_default.png`,
  /** うーんアイコン(投票済み) */
  img_icon_comment_negative_voted: `${imagePathRootAll}/icon_comment_negative_voted.png`,
  /** うーんアイコン(disable) */
  img_icon_comment_negative_disabled: `${imagePathRootAll}/icon_comment_negative_disabled.png`,

  /** ヤフコメ添削アイコン */
  img_icon_comment_feedback_pc: `${imagePathRootPc}/comment_feedback_kensaku_pc.png`,
  img_icon_comment_feedback_sp: `${imagePathRootSp}/comment_feedback_kensaku_sp.png`,

  /** フォローリスト0件時のけんさく */
  img_follow_no_content_sp: `${imagePathRootSp}/follow_no_content.png`,
  /** フォローリスト0件時の手のアイコン */
  img_follow_no_content_hand_icon: `${imagePathRootSp}/follow_no_content_hand_icon.png`,
  /** フォローリスト0件時の手のアクセントアイコン */
  img_follow_no_content_accent_hand_icon: `${imagePathRootSp}/follow_no_content_accent_hand_icon.png`,
  /** フォローリスト0件時のユーザアイコン1 */
  img_follow_no_content_user_icon1: `${imagePathRootSp}/follow_no_content_user_icon1.png`,
  /** フォローリスト0件時のユーザアイコン2 */
  img_follow_no_content_user_icon2: `${imagePathRootSp}/follow_no_content_user_icon2.png`,
  /** 初回フォロー時のダイアログ用バナー */
  img_follow_initial_banner: `${imagePathRootAll}/follow_initial_banner.png`,
  /** エキスパートフォローレコメンドアイコン */
  img_expert_follow_recommend_icon: `${imagePathRootSp}/expert_follow_recommend_icon.png`,
  /** コメントトレンドのデフォルト画像 */
  img_comment_trend_default_sp: `${imagePathRootSp}/comment_trend_default_sp.png`,

  /** スレッド投稿のけんさく */
  img_thread_post_kensaku_sp: `${imagePathRootSp}/thread_post_kensaku.svg`,
  /** スレッド誘導モジュールのけんさくえんじん */
  img_comment_thread_kensaku_enjin_sp: `${imagePathRootSp}/comment_thread_kensaku_enjin_sp.png`,
  /** コメントスレッド一覧誘導バナー */
  img_comment_thread_promotion_banner_sp: `${imagePathRootSp}/comment_thread_promotion_banner_sp.png`,
  /** コメント詳細からコメントスレッド一覧誘導バナー */
  img_comment_thread_promotion_comment_detail_banner_sp: `${imagePathRootSp}/comment_thread_promotion_comment_detail_banner_sp.png`,
  /** スレッド一覧 みんなの意見アイコン */
  img_comment_thread_polls_icon: `${imagePathRootAll}/comment_thread_polls_icon.png`
} as const;

/**
 * メディアクエリ mediaQuery
 *
 * ●使い方イメージ
 * const HOGE = styled.div`
 *  ${mediaQuery.iPhoneOver_sp} {
 *    color: red;
 *   }
 * `;
 */
export const mediaQuery = {
  /* SP */
  landscape_sp: '@media only screen and (orientation: landscape)' /* 端末横向き */,
  iPhoneOver_sp: '@media only screen and (min-width: 375px)' /* iPhoneサイズ以上(SE等は除く) */,
  iPhoneMin_sp: '@media only screen and (max-width: 374px)' /* 374px幅以下 */
} as const;

/**
 * トランジション　transition
 */

export const transition = {
  /* エクスパンドPC,SP共通 */
  /* エクスパンド要素の高さに応じて自然なアニメーションになるように適宜使い分ける */
  expand_short_visible_common: 'all 0.2s ease-in, opacity 0.1s ease-in 0.05s',
  expand_short_hidden_common: 'all 0.2s ease-out, opacity 0.1s ease-out 0s',
  expand_long_visible_common: 'all 0.4s ease-in, opacity 0.35s ease-in 0.15s',
  expand_long_hidden_common: 'all 0.4s ease-out, opacity 0.2s ease-out 0s',

  /* エクスパンド 開閉共用 PC,SP共通 */
  expand_toggle_common: 'all 0.3s ease-in-out',

  /* モーダル PC,SP共通 */
  modal_visible_common: 'all 0.4s ease-in',
  modal_hidden_common: 'all 0.4s ease-out',

  /* PC,SP共通 ホバー（透過度 opacity） */
  hover_opacity_pc: 'all 0.3s ease-in',

  /* PC ライブ カルーセルサムネイルのホバー（transform） */
  live_thumbnail_mouseover_pc: 'transform 0.3s ease-in',
  live_thumbnail_mouseout_pc: 'transform 0.3s ease-out',

  /* PC トップ ライブ チャンネル切り替え時のアニメーション */
  top_live_thumbnail_select_pc: 'transform 0.3s ease-out',

  /* PC ヘッダーナビゲーションのホバー */
  yjnHeader_hover_pc: 'all 0.2s' /* メインナビゲーション */,
  yjnHeader_sub_hover_pc: 'border-width 0.1s ease-in-out' /* サブナビゲーション */,

  /* PC 記事詳細のフローティングコメントの表示アニメーション */
  article_commentFloating_pc: 'all 0.7s ease',

  /* PC,SP共通 LIKE/DISLIKEのチュートリアルとボタンの表示アニメーション */
  timeline_likeButton_common: 'all 0.4s ease',

  /* PC,SP共通 コメンテーターの参考になったボタンでエラーになった時のアラート表示 */
  commentator_alert_common: 'all 0.1s ease-in-out',

  /* SP 上へ戻るボタンの表示アニメーション（opacity） */
  backToButton_sp: 'all 0.5s',

  /* SP スワイプナビゲーションボタンの表示アニメーション（位置） */
  swipeNaviButton_sp: 'all 0.1s',

  /* SP トップ地域モーダルのアニメーション（opacity） */
  localModal_sp: 'all 0.3s ease-in-out'
} as const;

/**
 * 文字サイズ fontSize
 */
export const fontSize = {
  px9: `${0.9 / 1.6}rem`,
  px10: `${1 / 1.6}rem`,
  px11: `${1.1 / 1.6}rem`,
  px12: `${1.2 / 1.6}rem`,
  px13: `${1.3 / 1.6}rem`,
  px14: `${1.4 / 1.6}rem`,
  px15: `${1.5 / 1.6}rem`,
  px16: `${1.6 / 1.6}rem`,
  px17: `${1.7 / 1.6}rem`,
  px18: `${1.8 / 1.6}rem`,
  px19: `${1.9 / 1.6}rem`,
  px20: `${2 / 1.6}rem`,
  px21: `${2.1 / 1.6}rem`,
  px22: `${2.2 / 1.6}rem`,
  px23: `${2.3 / 1.6}rem`,
  px24: `${2.4 / 1.6}rem`,
  px25: `${2.5 / 1.6}rem`,
  px26: `${2.6 / 1.6}rem`,
  px27: `${2.7 / 1.6}rem`,
  px28: `${2.8 / 1.6}rem`,
  px29: `${2.9 / 1.6}rem`,
  px30: `${3 / 1.6}rem`,
  px31: `${3.1 / 1.6}rem`,
  px32: `${3.2 / 1.6}rem`
} as const;
